// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"8":"packages","345":"portfolio","353":"contact","543":"gallery","594":"about","609":"faq"}[chunkId] + "." + {"8":"cccc4cd0","345":"239c4334","353":"bfcd9bf4","543":"5ccc7e18","594":"7bfd64e5","609":"282842e7"}[chunkId] + ".js";
};